import { inject, Injectable, signal } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import {
  ISnackBarData,
  EventTypeEnum,
  SNACKBAR_PERSISTENT_DURATION,
  snackbarIconsMapper,
} from '@dss-libs/shared/type/common-types';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private readonly translateService = inject(TranslocoService);
  private readonly _snackbarSignal = signal<ISnackBarData | null>(null);

  readonly snackbarSignal = this._snackbarSignal.asReadonly();

  showToaster(type: EventTypeEnum, message: string, persistent = false): void {
    this._snackbarSignal.set({
      type,
      icon: snackbarIconsMapper.get(type)!,
      message: this.translateService.translate(message),
      duration: persistent ? 0 : SNACKBAR_PERSISTENT_DURATION,
    });
  }
}
